import React, { Component, Fragment } from 'react'
import { FormPassword, FormSubmit } from '@myxplor/forms'
import PasswordPolicy from '../password-policy'
import HeadingRocket from '../heading-rocket'
class CompletePasswordResetView extends Component {
  render() {
    const {
      handleChange,
      handleSubmit,
      loading,
      errors = {},
      newPassword
    } = this.props

    return (
      <Fragment>
        <HeadingRocket>Password Reset</HeadingRocket>

        <p>Nearly done. Enter your new password, and you&#39;re good to go!</p>

        <form onSubmit={handleSubmit}>
          <fieldset>
            <FormPassword
              label='New Password'
              name="newPassword"
              required={true}
              onChange={handleChange}
              errors={errors.newPassword}
              loading={loading}
              value={newPassword}
            />
            <PasswordPolicy
              password={newPassword}
              errors={errors.passwordPolicy}
            />
          </fieldset>

          <FormSubmit
            loadingTitle="Resetting your password"
            errors={errors.submit || errors.summary}
            loading={loading}
          >Reset Password</FormSubmit>
        </form>
      </Fragment>
    )
  }
}

export default CompletePasswordResetView


// WEBPACK FOOTER //
// ./src/complete-password-reset/view.jsx